import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { StringParam, useQueryParams } from 'use-query-params'

export const useUTMCookies = (enable: boolean) => {
  const [UTMs] = useQueryParams({
    utmcampaign: StringParam,
    utmcontent: StringParam,
    utmmedium: StringParam,
    utmsource: StringParam,
    utmterm: StringParam,
  })

  useEffect(() => {
    if (enable && UTMs) {
      Object.entries(UTMs).forEach(([key, value]) => {
        if (value) {
          Cookies.set(`UTM_${key}`, value, {
            path: '/',
            domain: '.lalilo.com',
          })
        }
      })
    }
  }, [UTMs, enable])
}
